import client from '@/api/client';

export async function getCoupon({ code }) {
    return await client.get(`/coupons/${code}`);
}